import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { shouldShowListAsSupplierButton } from "../utils/buyerRfqRedirect";

export function useShowListAsSupplierButton() {
  const location = useLocation();
  const [visible, setVisible] = useState(() => shouldShowListAsSupplierButton());

  const sync = useCallback(() => {
    setVisible(shouldShowListAsSupplierButton());
  }, []);

  useEffect(() => {
    sync();
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, [sync, location.pathname, location.search]);

  return visible;
}
